export default {
  orderReturnDetails: {},
  selectedOrderReturn: {},
};
